import React from 'react';
import { Outlet } from 'react-router-dom';

import { Box, IconButton } from '@mui/material';

import { usePersistAppStore } from '@/app/persist-app-store';
import { ChannelTalkService } from '@/thirdparty/ChannelTalk/ChannelTalkInitialize';

import ChannelTalk from './channel-talk-icon.svg?react';

/**
 * 게스트일 때, 채널톡 레이아웃.
 */
export const GuestChannelTalkLayout = () => {
  const [messengerVisible, setMessengerVisible] = React.useState(false);

  const { deviceID } = usePersistAppStore();

  React.useEffect(() => {
    return ChannelTalkService.subscribeMessengerVisibility(setMessengerVisible);
  }, []);

  return (
    <Box>
      <Outlet />

      {!messengerVisible && (
        <Box sx={{ position: 'fixed', right: 20, bottom: 20, zIndex: 10 }}>
          <IconButton onClick={() => ChannelTalkService.showMessengerForGuest(deviceID)} sx={{ padding: 0 }}>
            <ChannelTalk />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
